export default __webpack_public_path__ + "static/thumbnail-50b1d158669ca2f46f5da5ea7ef0c1e1.png";